const $ = require('jquery');
global.$ = global.jQuery = $;

require('./loading');

$.migrateMute = true;
require('jquery-migrate');

require('slick-carousel');
require('slick-carousel/slick/slick.css');
require('slick-carousel/slick/slick-theme.css');

require('bootstrap');
